export default __webpack_public_path__ + "static/lut-virusi-d-r-taneva-7c6f0fa008e40d88cc289ec426ff35ed.jpg";